module.exports = __webpack_public_path__ + "img/close-eye.f8165858.svg";